import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useSuiviProjetsState } from './hooks/useSuiviProjetsState';
import Dashboard from './components/Dashboard';
import SuiviChantier from './components/SuiviChantier';

const SuiviProjets: React.FC = () => {
  const {
    projets,
    vueActive,
    projetSelectionne,
    ouvrirSuiviChantier,
    retourDashboard,
    ajouterSituation,
    ajouterTravauxSupplementaires,
    ajouterIncident,
    resoudreIncident,
    ajouterSituationSousTraitant,
  } = useSuiviProjetsState();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <header className="mb-8 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-bold text-violet-700 leading-tight">Suivi des Projets</h1>
            <p className="mt-2 text-base text-gray-600">
              {vueActive === 'dashboard'
                ? 'Vue d\'ensemble de vos projets et chantiers'
                : 'Suivi détaillé du chantier'}
            </p>
          </div>
          <div className="relative group">
            <button className="mt-1 text-gray-400 hover:text-violet-600 transition-colors">
              <QuestionMarkCircleIcon className="w-6 h-6" />
            </button>
            <div className="absolute right-0 top-full mt-2 w-64 bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
              <p className="font-semibold mb-1.5">Abréviations</p>
              <ul className="space-y-1">
                <li><span className="font-medium text-violet-300">MAT</span> : Marge À Terminaison</li>
                <li><span className="font-medium text-violet-300">PV</span> : Prix de Vente</li>
                <li><span className="font-medium text-violet-300">TS</span> : Travaux Supplémentaires</li>
                <li><span className="font-medium text-violet-300">ST</span> : Sous-Traitant</li>
                <li><span className="font-medium text-violet-300">OS</span> : Ordre de Service</li>
              </ul>
            </div>
          </div>
        </header>

        {vueActive === 'dashboard' ? (
          <Dashboard
            projets={projets}
            onOuvrirProjet={ouvrirSuiviChantier}
          />
        ) : projetSelectionne ? (
          <SuiviChantier
            projet={projetSelectionne}
            onRetour={retourDashboard}
            onAjouterSituation={ajouterSituation}
            onAjouterTS={(projetId, lotId, ts) =>
              ajouterTravauxSupplementaires(projetId, lotId, ts)
            }
            onAjouterIncident={ajouterIncident}
            onResoudreIncident={resoudreIncident}
            onAjouterSituationST={ajouterSituationSousTraitant}
          />
        ) : null}
      </div>
    </div>
  );
};

export default SuiviProjets;
